import { render, staticRenderFns } from "./GridInstagramFeed.vue?vue&type=template&id=5216cd3a&scoped=true&"
import script from "./GridInstagramFeed.vue?vue&type=script&lang=js&"
export * from "./GridInstagramFeed.vue?vue&type=script&lang=js&"
import style0 from "./GridInstagramFeed.vue?vue&type=style&index=0&id=5216cd3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216cd3a",
  null
  
)

export default component.exports